import { z } from "zod";

export const reploEnvSchema = z.enum([
  "production",
  "staging",
  "development",
  "test",
]);
export type ReploEnv = z.infer<typeof reploEnvSchema>;

export const ReploEnvs = {
  // Legacy cast - may or may not be necessary
  // eslint-disable-next-line replo/no-as-cast
  PRODUCTION: "production" as ReploEnv,
  // Legacy cast - may or may not be necessary
  // eslint-disable-next-line replo/no-as-cast
  STAGING: "staging" as ReploEnv,
  // Legacy cast - may or may not be necessary
  // eslint-disable-next-line replo/no-as-cast
  DEVELOPMENT: "development" as ReploEnv,
  // Legacy cast - may or may not be necessary
  // eslint-disable-next-line replo/no-as-cast
  TEST: "test" as ReploEnv,
};

export const ReploEnvsList = [
  ReploEnvs.PRODUCTION,
  ReploEnvs.STAGING,
  ReploEnvs.DEVELOPMENT,
  ReploEnvs.TEST,
] as const;

const SITE_HOSTS: Record<ReploEnv, string> = {
  production: "replosites.com",
  staging: "replosites-staging.com",
  development: "replosites-dev.com",
  test: "replosites-dev.com",
};

export function getSiteHost(env: ReploEnv): string {
  return SITE_HOSTS[env];
}

/**
 * The Cloudflare zone domain that actually hosts site traffic for each
 * environment. DNS records (CNAMEs, custom hostnames) must target this domain.
 * Distinct from SITE_HOSTS, which are the user-facing display domains.
 */
const SITE_HOSTING_DOMAINS: Record<ReploEnv, string> = {
  production: "reploshops.com",
  staging: "replosites-staging.com",
  development: "replosites-dev.com",
  test: "replosites-dev.com",
};

export function getSiteHostingDomain(env: ReploEnv): string {
  return SITE_HOSTING_DOMAINS[env];
}

export type CustomDomainEnv = "production" | "staging" | "development";

const CUSTOM_DOMAIN_ENVIRONMENTS: Record<ReploEnv, CustomDomainEnv> = {
  production: "production",
  staging: "staging",
  development: "development",
  test: "development",
};

export function getCustomDomainEnvironment(env: ReploEnv): CustomDomainEnv {
  return CUSTOM_DOMAIN_ENVIRONMENTS[env];
}
